import CustomZObject from './CustomZObject.js';
import {definitions} from './canvas/index.js';
import {isNumber} from "utils/IsNumber.js";

export default class ZCanvas extends CustomZObject {
    constructor(zobject) {
        super(zobject);
        this._color = "#000000";
        this.newInlet("operation", (q) => this.onOperationHelper(q));
        this.queue = [];
        window.requestAnimationFrame(() => this.draw());
    }

    onOperationHelper(q) {
        if (!Array.isArray(q)) {
            return;
        }
        let [y, ...x] = q;
        if (typeof y === "string") {
            this.onOperation(y, ...x);
            return;
        }
        if (!Array.isArray(y)) {
            return;
        }
        let [op, ...args] = y;
        if (Array.isArray(op)) {
            let [_op, ..._args] = op;
            this.onOperation(_op, ..._args);
        } else {
            this.onOperation(op, ...args);
        }
    }

    getFunctionDefinition(name) {
        return definitions[name];
    }
    
    enqueue(o) {
        this.queue.push(o);
    }

    onOperation(operation, ...vargs) {
        if (!this.ctxt) {
            return;
        }
        let getFn = (operation, ...vargs) => {
            if (!operation.split) {
                return;
            }
            let tokens = operation.split(' ').filter(x => x !== '');
            let name = tokens[0];
            let args = tokens.slice(1).map(
                x => isNumber(x) ? parseFloat(x) : x);
            
            let fn = this.getFunctionDefinition(name);
            if (!fn) {
                return undefined;
            }
            
            return () => fn(this, this.ctxt, ...args, ...vargs);
        };

        if (Array.isArray(operation)) {
            let list = operation.map(
                x => getFn(x, ...vargs)).filter(x => x).forEach(
                    x => this.enqueue(x, operation, ...vargs));
            if (!this.requested) {
                //this.draw();
                window.requestedTime = new Date().getTime();
                if (!this.first) {
                    //window.requestAnimationFrame(() => this.draw());
                    this.first = true;
                }
            }
            this.requested = true;
            return;
        }

        let fn = getFn(operation, ...vargs);
        if (fn) {
            this.enqueue(fn, operation, ...vargs);
        }
        if (!this.requested) {
            //this.draw();
            window.requestedTime = new Date().getTime();
            if (!this.first) {
                //window.requestAnimationFrame(() => this.draw());
                this.first=true;
            }
        }
        this.requested = true;
    }

    draw() {
        window.zRender.push(new Date().getTime() - window.requestedTime);
        window.lastRenderTime = new Date().getTime();
        window.renderSize.push(this.queue.length);
        this.queueforEach(
            fn => fn());
        this.queue.length = 0;
        this.requested=false;
        window.requestAnimationFrame(() => this.draw());
    }
}

window.renderSize = [];
window.zRender = [];

